import { GET } from "./api";

const SEARCH_BASE = "/website/search";

async function request(path) {
  const body = await GET(path);
  if (!body || body.success === false) {
    throw new Error(body?.message || `Request to ${path} failed`);
  }
  return body;
}

export async function getSearchCategories() {
  const body = await request(`${SEARCH_BASE}/categories`);
  return body?.data ?? [];
}

export async function getSearchSuggestions(categoryId, keyword) {
  const params = new URLSearchParams({
    categoryId: categoryId ?? "all",
    keyword: keyword ?? "",
  });
  const body = await request(`${SEARCH_BASE}/suggestions?${params.toString()}`);
  return body?.data ?? [];
}

export async function getSearchProducts(categoryId, keyword, page = 1, limit = 20) {
  const params = new URLSearchParams({
    categoryId: categoryId ?? "all",
    keyword: keyword ?? "",
    page: String(page),
    limit: String(limit),
  });
  const body = await request(`${SEARCH_BASE}/products?${params.toString()}`);
  return {
    items: body?.data ?? [],
    page: body?.page ?? page,
    limit: body?.limit ?? limit,
    total: body?.total ?? 0,
  };
}
